import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const useUrlState = (key: string, alwaysReplace: boolean = false) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const state = useMemo(() => searchParams.get(key), [key, searchParams]);

	const setState = useCallback(
		(value: string) => {
			const alreadySet = searchParams.get(key) !== null;
			setSearchParams(
				{ ...Object.fromEntries(searchParams.entries()), [key]: value },
				{
					replace: alreadySet || alwaysReplace,
				}
			);
		},
		[key, alwaysReplace, searchParams, setSearchParams]
	);

	const deleteState = useCallback(() => {
		const currentSearchParamsAsObject = Object.fromEntries(
			searchParams.entries()
		);
		delete currentSearchParamsAsObject[key];
		setSearchParams(currentSearchParamsAsObject, {
			replace: alwaysReplace,
		});
	}, [key, alwaysReplace, searchParams, setSearchParams]);

	return { state, setState, deleteState };
};

export default useUrlState;
